export default "__VITE_ASSET__DbGtJAQl__"